import { render, staticRenderFns } from "./NotificationMarkAllAsReadButton.vue?vue&type=template&id=5efb1592&"
import script from "./NotificationMarkAllAsReadButton.vue?vue&type=script&lang=js&"
export * from "./NotificationMarkAllAsReadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports